<template>
  <div :class="size">
    <div
      class="input-group"
      :class="`${disabled ? 'disabled' : ''} ${getInputGroupClass}`"
    >
      <textarea
        :style="inputStyle"
        class="form-control"
        :placeholder="placeholder"
        :value="modelValue"
        :id="id"
        :disabled="disabled"
        @input="updateValue($event)"
      />
    </div>
    <div v-if="dispCharRemaining" class="textarea-char-remaining">
      <i18n-t keypath="charactersRemaining">
        <b>{{ getCharCountRemaining }}&nbsp;</b>
      </i18n-t>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'RexFormInput',

  data() {
    return {
      inputVal: '',
    };
  },
  props: {
    unit: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    // type: { type: String, default: 'text' },
    id: { type: String, required: true },
    size: { type: String, default: 'sm' },
    inputStyle: { type: String, default: '' },
    unitRequired: { type: Boolean, default: false },
    modelValue: {},
    disabled: { type: Boolean, default: false },
    dispCharRemaining: { type: Boolean, default: false },
    maxCharLimit: { type: Number, default: 500 },
  },
  methods: {
    updateValue: function (event) {
      if (
        this.dispCharRemaining &&
        event.target.value?.length > this.maxCharLimit
      ) {
        event.target.value = event.target.value.slice(0, this.maxCharLimit);
      }
      this.inputVal = event.target.value;
      this.$emit('update:modelValue', event.target.value);
    },
  },
  // mounted() {
  //   if (this.updateVal) {
  //     this.inputVal = this.updateVal;
  //   }
  // },
  computed: {
    unitAppend() {
      if (this.unit === '') {
        return '';
      }
      return '| ' + this.unit;
    },
    getInputGroupClass() {
      return this.dispCharRemaining && 'input-group-char-remaing';
    },
    getCharCountRemaining() {
      return this.maxCharLimit - (this.modelValue.length || 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  background-color: $bg-primary;
  color: $font-primary;
  //border: 0.0625 black solid;
  border: none;
  height: 100%;
  resize: none;
}
.input-last {
  background-color: $bg-primary;
  border: 0.125em;
}
.sm {
  min-width: 12.5em;
}
.lg {
  min-width: 18.75em;
}
.input-group-text {
  color: $font-primary;
  background: $bg-primary;
  border: none;
}
.input-group-append {
  border-top-right-radius: 0.375em;
  border-bottom-right-radius: 0.375em;
  color: $font-primary;
  background-color: $bg-primary;
  padding: 0.3125em;
  text-align: left;
}
.input-group {
  background: $bg-primary;
  border-radius: 0.375rem;
  border: 0.0625em $border-primary solid;
  height: 100%;
}
/*
textarea[type='text'] {
  box-sizing: border-box;
  border: none;
  border-radius: 7px;
  background-color: $bg-primary;
  color: $font-primary;
}
textarea[type='number'] {
  box-sizing: border-box;
  border: none;
  border-radius: 0.375rem;
  background-color: $bg-primary;
  color: $font-primary;
}
.cust-modal-input:focus {
  outline: none !important;
}*/
textarea:focus {
  outline: none !important;
  box-shadow: none;
  background-color: $bg-primary;
  color: $font-primary;
}
.disabled {
  color: $border-color-primary-disabled;
}
.input-group-char-remaing {
  border-bottom-left-radius: 0rem;
  border-bottom-right-radius: 0rem;
}
.textarea-char-remaining {
  @include flex-center-justify(flex-end);
  background-color: $bg-primary;
  width: 100%;
  padding: 0.625rem 1rem 1rem 0rem;

  border-left: 0.0625em $border-primary solid;
  border-right: 0.0625em $border-primary solid;
  border-bottom: 0.0625em $border-primary solid;
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
</style>
